/*
 * Derpy Cards — frontend enhancements
 * ------------------------------------------------------------------
 * Phase 1: Make product cards open the QUICK-VIEW popup instead of
 * navigating to a full product page, and give that popup a clean,
 * shareable /products/{handle} URL via the History API (so links are
 * SEO-friendly and the browser back button just closes the popup).
 *
 * Self-contained: depends only on stable theme DOM that is rendered
 * globally in layout/theme.liquid (#Product-Drawer, #Product-Drawer-Content,
 * .click-capture--product, body.open-cc--product). It does NOT modify the
 * bundled app.js, so a theme update can't silently break it.
 * Full product pages remain crawlable canonical fallbacks
 * (cmd/ctrl/middle-click still open them in a new tab).
 */
(function () {
  'use strict';

  var rootUrl = (window.theme && theme.routes && theme.routes.root_url) || '';
  if (rootUrl === '/') rootUrl = '';

  var drawer  = function () { return document.getElementById('Product-Drawer'); };
  var content = function () { return document.getElementById('Product-Drawer-Content'); };
  var scrim   = function () { return document.querySelector('.click-capture--product'); };

  var state = { open: false, pushed: false, returnUrl: null, trigger: null };

  var SKELETON =
    '<div class="derpy-qv-skeleton">' +
    '<div class="derpy-qv-skeleton__img derpy-skeleton"></div>' +
    '<div class="derpy-qv-skeleton__line sm derpy-skeleton"></div>' +
    '<div class="derpy-qv-skeleton__line lg derpy-skeleton"></div>' +
    '<div class="derpy-qv-skeleton__line derpy-skeleton"></div>' +
    '<div class="derpy-qv-skeleton__line price derpy-skeleton"></div>' +
    '<div class="derpy-qv-skeleton__btn derpy-skeleton"></div>' +
    '</div>';

  function handleFromUrl(url) {
    var m = /\/products\/([^/?#]+)/.exec(url || '');
    return m ? m[1] : null;
  }
  function cleanProductUrl(handle) {
    return (rootUrl + '/products/' + handle).replace('//', '/');
  }

  function openDrawerDom() {
    var d = drawer(); if (!d) return;
    document.body.classList.add('open-cc--product');
    d.classList.add('active');
    d.removeAttribute('inert');
    d.setAttribute('tabindex', '-1');
    try { d.focus(); } catch (e) {}
  }
  function doClose() {
    state.open = false;
    var d = drawer();
    if (d) {
      document.body.classList.remove('open-cc--product');
      d.classList.remove('active');
      d.setAttribute('inert', '');
    }
    var c = content();
    if (c) setTimeout(function () { if (!state.open) c.innerHTML = ''; }, 300);
    var t = state.trigger;
    state.trigger = null; state.pushed = false; state.returnUrl = null;
    if (t && typeof t.focus === 'function') { try { t.focus(); } catch (e) {} }
  }

  function fetchAndOpen(handle, opts) {
    var d = drawer(), c = content();
    if (!d || !c) { window.location.href = cleanProductUrl(handle); return; }
    var url = (rootUrl + '/products/' + handle + '?view=quick-view').replace('//', '/');
    if (opts && opts.trigger) opts.trigger.classList.add('loading');
    c.innerHTML = SKELETON;        // instant feedback while the section fetches
    openDrawerDom();
    fetch(url, { method: 'GET' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (opts && opts.trigger) opts.trigger.classList.remove('loading');
        var inner = new DOMParser().parseFromString(text, 'text/html')
          .querySelector('#Product-Drawer-Content');
        if (!inner) { window.location.href = cleanProductUrl(handle); return; }
        c.innerHTML = inner.innerHTML;
        // Re-execute any inline/linked scripts that came with the section
        c.querySelectorAll('script').forEach(function (s) {
          var n = document.createElement('script');
          if (s.src) { n.src = s.src; } else { n.textContent = s.textContent; }
          document.head.appendChild(n);
        });
        setTimeout(function () {
          try { if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init(); } catch (e) {}
          try { if (window.ProductModel) window.ProductModel.loadShopifyXR(); } catch (e) {}
        }, 300);
        openDrawerDom();
      })
      .catch(function () {
        if (opts && opts.trigger) opts.trigger.classList.remove('loading');
        window.location.href = cleanProductUrl(handle);
      });
  }

  function open(handle, opts) {
    if (!handle) return;
    opts = opts || {};
    if (!state.open) {
      state.returnUrl = location.pathname + location.search + location.hash;
      state.trigger = opts.trigger || null;
    }
    state.open = true;
    fetchAndOpen(handle, opts);
    try {
      history.pushState({ derpyQuickView: handle }, '', cleanProductUrl(handle));
      state.pushed = true;
    } catch (e) {}
  }

  function uiClose() {
    if (!state.open) return;
    if (state.pushed && history.state && history.state.derpyQuickView) {
      history.back();            // pops the quick-view entry -> popstate -> doClose()
    } else {
      doClose();
    }
  }

  // --- Card click -> quick-view popup -------------------------------------
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return; // new-tab intents
    var link = e.target.closest && e.target.closest('a.product-card--image-link, a.product-card-title');
    if (!link) return;
    if (!link.closest('.product-card, product-card')) return;
    var handle = handleFromUrl(link.getAttribute('href'));
    if (!handle) return;
    e.preventDefault();
    open(handle, { trigger: link });
  }, false);

  // --- Theme's own quick-view (e.g. sold-out buttons) -> also push URL -----
  document.addEventListener('quick-view:open', function (e) {
    var handle = e && e.detail && e.detail.productHandle;
    if (!handle || state.open) return;
    state.returnUrl = location.pathname + location.search + location.hash;
    state.open = true;
    try {
      history.pushState({ derpyQuickView: handle }, '', cleanProductUrl(handle));
      state.pushed = true;
    } catch (err) {}
  });

  // --- Close affordances ---------------------------------------------------
  document.addEventListener('click', function (e) {
    var s = scrim();
    var closeBtn = e.target.closest && e.target.closest('#Product-Drawer side-panel-close, #Product-Drawer .side-panel-close, #Product-Drawer [data-drawer-close]');
    if ((s && e.target === s) || closeBtn) uiClose();
  }, false);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && state.open) uiClose();
  });

  // Back / forward button closes the quick-view and restores the list URL
  window.addEventListener('popstate', function () {
    if (state.open) doClose();
  });

  window.DerpyQuickView = { open: open, close: uiClose };
})();


/*
 * Collection: top "Filters & Sort" bar + off-canvas drawer for the Cloud Search
 * filter app. Keeps the app's real filters working (same DOM, just repositioned
 * by CSS) and frees the full width for a denser grid. No-ops on non-collection pages.
 */
(function () {
  'use strict';
  var built = false;
  var root = (window.theme && theme.routes && theme.routes.root_url) || '';
  if (root === '/') root = '';

  var IC = {
    filter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>',
    chev: '<svg class="derpy-fd__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>'
  };

  var IN_STOCK_KEY = 'filter_availability[in_stock]';
  var DEFAULT_SORT = 'created-descending';
  var SORTS = [
    ['created-descending', 'Newest'],
    ['price-ascending', 'Price: Low to High'],
    ['price-descending', 'Price: High to Low']
  ];

  function handle() { var m = /\/(?:collections|a\/search)\/([^/?#]+)/.exec(location.pathname); return m ? m[1] : null; }
  function qp() { return new URLSearchParams(location.search); }
  function navTo(p) { var qs = p.toString(); location.assign(root + '/a/search/' + handle() + (qs ? ('?' + qs) : '')); }
  function prettyName(key) {
    var n = key.replace(/^filter_/, '').replace(/_filter$/, '').replace(/_/g, ' ');
    return n.charAt(0).toUpperCase() + n.slice(1);
  }

  function build() {
    if (built) return;
    var sidebar = document.getElementById('cloud_search_filters_sidebar');
    var products = document.querySelector('.sidebar-container--products');
    if (!sidebar || !products) return;
    if (!sidebar.querySelector('.cloud-search-filter')) return; // wait for app to inject filters
    built = true;

    var p = qp();

    /* off-canvas "More filters" drawer plumbing */
    var scrim = document.createElement('div'); scrim.className = 'derpy-filter-scrim'; document.body.appendChild(scrim);
    var closeBtn = document.createElement('button'); closeBtn.type = 'button'; closeBtn.className = 'derpy-filter-close';
    closeBtn.setAttribute('aria-label', 'Close filters'); closeBtn.innerHTML = IC.x; document.body.appendChild(closeBtn);
    function openD() { document.body.classList.add('derpy-filters-open'); }
    function closeD() { document.body.classList.remove('derpy-filters-open'); }
    closeBtn.addEventListener('click', closeD); scrim.addEventListener('click', closeD);
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && document.body.classList.contains('derpy-filters-open')) closeD(); });

    var bar = document.createElement('div'); bar.className = 'derpy-toolbar';

    /* Category name (for the scoped-search pill + the relocated breadcrumb) */
    var crumbNav = document.querySelector('#shopify-section-breadcrumbs nav.breadcrumbs');
    var catName = '';
    if (crumbNav) { var bcl = crumbNav.querySelectorAll('a'); if (bcl.length) catName = bcl[bcl.length - 1].textContent.trim(); }
    if (!catName) { var hcat = handle(); catName = hcat ? prettyName('filter_' + hcat) : 'this category'; }

    /* Search within category — given a category "scope" pill + green accent so
       it reads clearly different from the global (store-wide) header search. */
    var sform = document.createElement('form'); sform.className = 'derpy-tb-search'; sform.setAttribute('role', 'search');
    sform.innerHTML = IC.search;
    var sinput = document.createElement('input'); sinput.type = 'search'; sinput.className = 'derpy-tb-search__input';
    sinput.placeholder = 'Search ' + catName + '…'; sinput.value = p.get('filter_search') || ''; sinput.setAttribute('aria-label', 'Search within ' + catName);
    sform.appendChild(sinput);
    sform.addEventListener('submit', function (e) {
      e.preventDefault(); var np = qp(); var v = sinput.value.trim();
      if (v) np.set('filter_search', v); else np.delete('filter_search'); navTo(np);
    });

    /* In-stock toggle (default on) */
    var inStock = p.get(IN_STOCK_KEY) === 'true';
    var stockBtn = document.createElement('button'); stockBtn.type = 'button';
    stockBtn.className = 'derpy-tb-toggle' + (inStock ? ' is-on' : ''); stockBtn.setAttribute('aria-pressed', inStock ? 'true' : 'false');
    stockBtn.innerHTML = '<span class="derpy-tb-toggle__track"><span class="derpy-tb-toggle__dot"></span></span><span>In stock</span>';
    stockBtn.addEventListener('click', function () {
      var np = qp();
      if (inStock) { np.delete(IN_STOCK_KEY); if (!np.get('sort_by')) np.set('sort_by', DEFAULT_SORT); }
      else { np.set(IN_STOCK_KEY, 'true'); }
      navTo(np);
    });

    /* Sort (Newest default + highlighted) */
    var cur = p.get('sort_by') || DEFAULT_SORT;
    var sortWrap = document.createElement('div'); sortWrap.className = 'derpy-tb-sort';
    var opts = SORTS.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === cur ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('');
    sortWrap.innerHTML = '<span class="derpy-tb-sort__label">Sort</span><span class="derpy-tb-select"><select aria-label="Sort by">' + opts + '</select></span>';
    sortWrap.querySelector('select').addEventListener('change', function () { var np = qp(); np.set('sort_by', this.value); navTo(np); });

    /* Individual facet dropdowns — one button per filter, each opening its own
       dropdown straight from the toolbar (no monolithic "All filters" panel). */
    var SKIP_FACET = /search|availab|in stock|sort/i;
    var facetDropdowns = [];
    var openFD = null;
    function closeAllFD() {
      if (openFD) { openFD.fd.classList.remove('is-open'); openFD.btn.setAttribute('aria-expanded', 'false'); openFD = null; }
    }
    [].forEach.call(sidebar.querySelectorAll('.cloud-search-filter'), function (group) {
      var nameEl = group.querySelector('.cloud-search-filter__name');
      var label = nameEl ? nameEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!label || SKIP_FACET.test(label)) { group.style.display = 'none'; return; }
      var fd = document.createElement('div');
      fd.className = 'derpy-fd';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'derpy-fd__btn';
      btn.setAttribute('aria-haspopup', 'true');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>' + label + '</span>' + IC.chev;
      var panel = document.createElement('div');
      panel.className = 'derpy-fd__panel';
      panel.appendChild(group); // relocate the app's filter group into this dropdown
      fd.appendChild(btn);
      fd.appendChild(panel);

      // Language facet: the app prefixes every value with "Language_" (e.g.
      // "Language_English"). Strip it from the DISPLAY text only — the app applies
      // the filter from its own internal state, not this text, so filtering is
      // unaffected. Values render lazily + can re-render, so watch the group.
      if (/^language$/i.test(label)) {
        var stripLang = function () {
          var nm = group.querySelectorAll('.cloud-search-filter-value__name');
          for (var i = 0; i < nm.length; i++) {
            var t = nm[i].textContent;
            if (/^\s*language[_\s]/i.test(t)) nm[i].textContent = t.replace(/^\s*language[_\s]+/i, '');
          }
        };
        var lmo = new MutationObserver(function () { lmo.disconnect(); stripLang(); lmo.observe(group, { childList: true, subtree: true }); });
        lmo.observe(group, { childList: true, subtree: true });
      }
      var expanded = false;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = fd.classList.contains('is-open');
        closeAllFD();
        if (wasOpen) return;
        /* Self-heal: the app sometimes re-renders its (hidden) sidebar, leaving
           our panel holding a stale/empty copy of this filter — that's the
           "dropdown opens but doesn't work" bug. Re-adopt the fresh group. */
        try {
          var mine = panel.querySelector('.cloud-search-filter');
          var fresh = null;
          [].forEach.call(sidebar.querySelectorAll('.cloud-search-filter'), function (g) {
            if (g === mine) return;
            var n = g.querySelector('.cloud-search-filter__name');
            var l = n ? n.textContent.replace(/\s+/g, ' ').trim() : '';
            if (l === label) fresh = g;
          });
          if (fresh) {
            if (mine) mine.remove();
            panel.appendChild(fresh);
            nameEl = fresh.querySelector('.cloud-search-filter__name');
            expanded = false;
            if (/^language$/i.test(label)) {
              [].forEach.call(fresh.querySelectorAll('.cloud-search-filter-value__name'), function (nm) {
                nm.textContent = nm.textContent.replace(/^\s*language[_\s]+/i, '');
              });
            }
          }
        } catch (err) {}
        if (!expanded && nameEl) { try { nameEl.click(); } catch (err) {} expanded = true; } // expand → app renders values
        fd.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        openFD = { fd: fd, btn: btn };
        panel.style.left = ''; panel.style.right = '';
        requestAnimationFrame(function () {
          var r = panel.getBoundingClientRect();
          if (r.right > window.innerWidth - 8) { panel.style.left = 'auto'; panel.style.right = '0'; }
        });
      });
      facetDropdowns.push(fd);
    });
    document.addEventListener('click', function (e) { if (openFD && !openFD.fd.contains(e.target)) closeAllFD(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') closeAllFD(); });

    /* Count */
    var n = document.querySelectorAll('#product-grid .product-card').length;
    var count = document.createElement('span'); count.className = 'derpy-tb-count'; if (n) count.textContent = n + ' shown';

    /* LEFT — relocate the breadcrumb into the toolbar so the page-path and the
       filters share one row (the original section is hidden via CSS). */
    var crumbSlot = document.createElement('div'); crumbSlot.className = 'derpy-tb-crumb';
    if (crumbNav) { crumbSlot.appendChild(crumbNav); }

    /* CENTER — the filter controls, kept centered in the toolbar grid. */
    var center = document.createElement('div'); center.className = 'derpy-tb-center';
    center.appendChild(sform); center.appendChild(stockBtn); center.appendChild(sortWrap);
    facetDropdowns.forEach(function (fd) { center.appendChild(fd); });

    /* RIGHT — result count */
    var right = document.createElement('div'); right.className = 'derpy-tb-right';
    right.appendChild(count);

    bar.appendChild(crumbSlot);
    bar.appendChild(center);
    bar.appendChild(right);

    /* Active filter chips */
    var chipsRow = document.createElement('div'); chipsRow.className = 'derpy-tb-chips';
    var chips = [];
    p.forEach(function (v, k) {
      if (k === 'filter_search') chips.push({ k: k, label: '“' + v + '”' });
      // Any active facet param (filter_set_name, filter_rarity_filter, filter_language, …)
      // gets a removable chip. Availability is the in-stock toggle; search has its own chip.
      else if (k.indexOf('filter_') === 0 && k.indexOf('filter_availability') !== 0) {
        var dv = v.replace(/^\s*language[_\s]+/i, ''); // drop the "Language_" prefix in chips too
        chips.push({ k: k, label: prettyName(k) + ': ' + dv });
      }
    });
    chips.forEach(function (c) {
      var chip = document.createElement('button'); chip.type = 'button'; chip.className = 'derpy-tb-chip';
      chip.innerHTML = '<span>' + c.label + '</span>' + IC.x;
      chip.addEventListener('click', function () { var np = qp(); np.delete(c.k); navTo(np); });
      chipsRow.appendChild(chip);
    });
    if (chips.length) {
      var clearAll = document.createElement('button'); clearAll.type = 'button'; clearAll.className = 'derpy-tb-clear'; clearAll.textContent = 'Clear all';
      clearAll.addEventListener('click', function () { navTo(new URLSearchParams('sort_by=' + DEFAULT_SORT + '&' + IN_STOCK_KEY + '=true')); });
      chipsRow.appendChild(clearAll);
    }

    products.insertBefore(bar, products.firstChild);
    if (chips.length) products.insertBefore(chipsRow, bar.nextSibling);
    document.body.classList.add('derpy-filters-ready');
    setHeaderHeight();
    setTimeout(setHeaderHeight, 300);
    forceRevealGrid();
    killRevealTriggers();
  }

  /* The Cloud Search app injects product cards AFTER the theme's ScrollTrigger
     scroll-reveal has already run on load, so late-injected / below-the-fold
     cards can be left in the animation's initial hidden state (opacity:0,
     scale) — which looked like "missing cards at the end of the gallery" on
     taller/narrower layouts. Force every card image to its revealed state with
     inline !important (beats both the CSS initial state and any GSAP inline). */
  function forceRevealGrid() {
    try {
      var els = document.querySelectorAll('#product-grid .product-card--image-primary, #product-grid .product-card--image, .products .product-card--image-primary');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.getAttribute('data-derpy-revealed')) continue; // stamp once, no per-tick churn
        var s = el.style;
        s.setProperty('opacity', '1', 'important');
        s.setProperty('visibility', 'visible', 'important');
        s.setProperty('transform', 'none', 'important');
        el.setAttribute('data-derpy-revealed', '1');
      }
    } catch (e) {}
  }

  /* The theme's scroll-reveal ScrollTriggers keep doing per-scroll work on
     cards we've already force-revealed — dead weight that made scrolling feel
     rough/stuttery (and the old ScrollTrigger.refresh() polling here was worse:
     ~100 full recalcs in the first seconds = "page is slowing down" warnings).
     Kill just the card-image reveal triggers; nothing else is touched. */
  function killRevealTriggers() {
    try {
      if (!window.ScrollTrigger) return;
      window.ScrollTrigger.getAll().forEach(function (st) {
        var el = st.trigger || (st.vars && st.vars.trigger);
        if (el && el.matches && el.matches('.product-card--image-primary, .collection-card--link')) st.kill();
      });
    } catch (e) {}
  }

  function setHeaderHeight() {
    var h = document.querySelector('sticky-header, theme-header, #header');
    if (h) {
      var hh = Math.round(h.getBoundingClientRect().height);
      if (hh > 0) document.documentElement.style.setProperty('--derpy-header-h', hh + 'px');
    }
    var tb = document.querySelector('.derpy-toolbar');
    if (tb) {
      var th = Math.round(tb.getBoundingClientRect().height);
      if (th > 0) document.documentElement.style.setProperty('--derpy-toolbar-h', th + 'px');
    }
  }

  function start() {
    setHeaderHeight();
    setTimeout(setHeaderHeight, 600);
    window.addEventListener('resize', setHeaderHeight);
    var tries = 0;
    var iv = setInterval(function () { tries++; build(); if (built || tries > 60) clearInterval(iv); }, 200);
    /* Reveal safety net for cards the app injects late: a short, cheap loop
       (stamp-once, NO ScrollTrigger.refresh), then stop. */
    forceRevealGrid();
    var rTries = 0;
    var rv = setInterval(function () {
      rTries++;
      forceRevealGrid();
      if (rTries === 6) killRevealTriggers();
      if (rTries > 12) clearInterval(rv);
    }, 500);
    window.addEventListener('load', function () { forceRevealGrid(); killRevealTriggers(); });
    document.addEventListener('theme:reload_animations', function () {
      setTimeout(function () { forceRevealGrid(); killRevealTriggers(); }, 50);
    });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();


/*
 * Fix: the "Yu-Gi-Oh!" top-nav item has no URL set in the menu, so it isn't
 * clickable (every other category links to its collection). Set its href to
 * the Yu-Gi-Oh collection. Theme-side only — does not touch the live menu config.
 */
(function () {
  'use strict';
  function fixYgo() {
    var links = document.querySelectorAll('.full-menu a, .header-menu a, nav a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^yu\-?gi\-?oh/i.test(t)) continue;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.trim() === '') {
        a.setAttribute('href', '/collections/yu-gi-oh-1');
      }
    }
  }
  if (document.readyState !== 'loading') fixYgo();
  else document.addEventListener('DOMContentLoaded', fixYgo);
})();


/*
 * Quick-view image zoom lightbox: click a product image inside the quick-view
 * slide-out to open it fullscreen with zoom in/out (+/- buttons, scroll wheel,
 * double-click) and drag-to-pan, so cards can be inspected super up close.
 * Requests a high-res (width=2048) version of the image for sharp zooming.
 */
(function () {
  'use strict';
  var overlay, stage, img, levelEl, countEl;
  var images = [], curIndex = 0;
  var scale = 1, minScale = 1, maxScale = 6, tx = 0, ty = 0;
  var panning = false, startX = 0, startY = 0, baseTx = 0, baseTy = 0;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'derpy-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Image viewer');
    overlay.innerHTML =
      '<div class="derpy-zoom-hint">Scroll or +/− to zoom · drag to pan · ← → for images</div>' +
      '<button class="derpy-zoom-close" type="button" aria-label="Close">×</button>' +
      '<button class="derpy-zoom-nav derpy-zoom-nav--prev" type="button" aria-label="Previous image">‹</button>' +
      '<button class="derpy-zoom-nav derpy-zoom-nav--next" type="button" aria-label="Next image">›</button>' +
      '<div class="derpy-zoom-stage"><img class="derpy-zoom-img" alt=""></div>' +
      '<div class="derpy-zoom-count"></div>' +
      '<div class="derpy-zoom-controls">' +
        '<button class="derpy-zoom-btn" type="button" data-z="out" aria-label="Zoom out">−</button>' +
        '<span class="derpy-zoom-level">100%</span>' +
        '<button class="derpy-zoom-btn" type="button" data-z="in" aria-label="Zoom in">+</button>' +
      '</div>';
    document.body.appendChild(overlay);
    stage = overlay.querySelector('.derpy-zoom-stage');
    img = overlay.querySelector('.derpy-zoom-img');
    levelEl = overlay.querySelector('.derpy-zoom-level');
    countEl = overlay.querySelector('.derpy-zoom-count');

    overlay.querySelector('.derpy-zoom-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay || e.target === stage) close(); });
    overlay.querySelector('.derpy-zoom-nav--prev').addEventListener('click', function (e) { e.stopPropagation(); navStep(-1); });
    overlay.querySelector('.derpy-zoom-nav--next').addEventListener('click', function (e) { e.stopPropagation(); navStep(1); });
    [].forEach.call(overlay.querySelectorAll('.derpy-zoom-btn'), function (b) {
      b.addEventListener('click', function () { zoomBy(b.getAttribute('data-z') === 'in' ? 1.4 : 1 / 1.4); });
    });
    stage.addEventListener('wheel', function (e) { e.preventDefault(); zoomAt(e.deltaY < 0 ? 1.18 : 1 / 1.18, e.clientX, e.clientY); }, { passive: false });
    stage.addEventListener('pointerdown', function (e) {
      if (scale <= minScale) return;
      panning = true; stage.classList.add('is-panning');
      startX = e.clientX; startY = e.clientY; baseTx = tx; baseTy = ty;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    });
    stage.addEventListener('pointermove', function (e) {
      if (!panning) return; tx = baseTx + (e.clientX - startX); ty = baseTy + (e.clientY - startY); apply();
    });
    function endPan() { panning = false; stage.classList.remove('is-panning'); }
    stage.addEventListener('pointerup', endPan);
    stage.addEventListener('pointercancel', endPan);
    img.addEventListener('dblclick', function (e) { zoomAt(scale > minScale ? (minScale / scale) : 2.5, e.clientX, e.clientY); });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === '+' || e.key === '=') zoomBy(1.4);
      else if (e.key === '-' || e.key === '_') zoomBy(1 / 1.4);
      else if (e.key === 'ArrowLeft') navStep(-1);
      else if (e.key === 'ArrowRight') navStep(1);
    });
  }

  function apply() {
    if (scale <= minScale) { tx = 0; ty = 0; }
    img.style.transform = 'translate(calc(-50% + ' + tx + 'px), calc(-50% + ' + ty + 'px)) scale(' + scale + ')';
    levelEl.textContent = Math.round(scale * 100) + '%';
    stage.style.cursor = scale > minScale ? 'grab' : 'zoom-out';
  }
  function zoomBy(f) { scale = Math.min(maxScale, Math.max(minScale, scale * f)); apply(); }
  function zoomAt(f, cx, cy) {
    var prev = scale;
    scale = Math.min(maxScale, Math.max(minScale, scale * f));
    var r = stage.getBoundingClientRect();
    var ox = cx - r.left - r.width / 2, oy = cy - r.top - r.height / 2;
    var ratio = scale / prev;
    tx = (tx - ox) * ratio + ox; ty = (ty - oy) * ratio + oy;
    apply();
  }
  function hires(src) { try { var u = new URL(src, location.href); if (/cdn\.shopify\.com|\/cdn\//.test(u.href)) { u.searchParams.set('width', '2048'); } return u.href; } catch (e) { return src; } }
  function showImage(i) {
    if (!images.length) return;
    curIndex = (i % images.length + images.length) % images.length;
    scale = 1; tx = 0; ty = 0;
    img.src = hires(images[curIndex]); apply();
    if (countEl) countEl.textContent = (curIndex + 1) + ' / ' + images.length;
    overlay.classList.toggle('is-single', images.length <= 1);
  }
  function navStep(d) { if (images.length > 1) showImage(curIndex + d); }
  function open(list, index) {
    build();
    images = (list && list.length) ? list : [];
    document.body.classList.add('derpy-zoom-lock');
    showImage(index || 0);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }
  function close() { if (overlay) { overlay.classList.remove('is-open'); document.body.classList.remove('derpy-zoom-lock'); } }

  document.addEventListener('click', function (e) {
    var im = e.target.closest && e.target.closest('#Product-Drawer .product-quick-images img, .thb-product-detail .product-quick-images img');
    if (!im) return;
    e.preventDefault(); e.stopPropagation();
    var clicked = im.currentSrc || im.src;
    // gather every image in this product's quick-view gallery (dedupe Flickity clones)
    var gallery = im.closest('.product-quick-images') || document;
    var seen = {}, list = [];
    [].forEach.call(gallery.querySelectorAll('img'), function (g) {
      var s = g.currentSrc || g.src;
      if (s && !seen[s]) { seen[s] = 1; list.push(s); }
    });
    if (!list.length) list = [clicked];
    var idx = list.indexOf(clicked); if (idx < 0) idx = 0;
    open(list, idx);
  }, true);
})();


/*
 * #6 — "Blogs" nav: rename to "News", point it at /blogs/news, and remove its
 * dropdown (the consolidated content lives in the News blog). Theme-side only —
 * does not modify the live menu config.
 */
(function () {
  'use strict';
  function fixBlogs() {
    var tops = document.querySelectorAll('.full-menu > ul > li, .header-menu > ul > li, .full-menu li.menu-item-has-children');
    [].forEach.call(tops, function (li) {
      var a = li.querySelector(':scope > a');
      if (!a) return;
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^blogs?$/i.test(t)) return;
      a.textContent = 'News';
      a.setAttribute('href', '/blogs/news');
      li.classList.remove('menu-item-has-children');
      var sub = li.querySelector('ul'); if (sub) sub.parentNode.removeChild(sub);
    });
  }
  if (document.readyState !== 'loading') fixBlogs();
  else document.addEventListener('DOMContentLoaded', fixBlogs);
})();


/*
 * Data hygiene: the card importer (Store Pass) leaves literal "null" values in
 * spec rows ("Form: null - Evolves from null"). Hide/strip those on product
 * pages AND inside the quick-view drawer. Lowercase-only matching keeps real
 * names like the Pokémon "Type: Null" intact.
 */
(function () {
  'use strict';
  function clean(root) {
    try {
      var rows = (root || document).querySelectorAll('.store-pass-custom-description .info-item');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (row.getAttribute('data-derpy-cleaned')) continue;
        row.setAttribute('data-derpy-cleaned', '1');
        var label = row.querySelector('label');
        var val = (row.textContent || '').replace(label ? label.textContent : '', '').trim();
        if (/^null\b/.test(val)) { row.style.display = 'none'; }
        else if (/\bnull\b/.test(val)) {
          row.innerHTML = row.innerHTML.replace(/\s*[-–—]?\s*(Evolves from\s+)?null\b/g, '');
        }
      }
    } catch (e) {}
  }
  function start() {
    clean(document);
    var drawer = document.getElementById('Product-Drawer-Content');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { clean(drawer); }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();


/*
 * Smart bars (mobile): scrolling down tucks the fixed header + filter toolbar
 * away for full-screen browsing; the moment the user scrolls up a little,
 * both slide back in. Desktop keeps them permanently sticky (unchanged).
 */
(function () {
  'use strict';
  if (!document.documentElement.classList.contains('derpy-grid-page')) return;
  var mq = window.matchMedia('(max-width: 768px)');
  var lastY = window.scrollY || 0, ticking = false;
  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    var cls = document.documentElement.classList;
    if (!mq.matches) { cls.remove('derpy-bars-hide'); lastY = y; return; }
    var dy = y - lastY;
    if (y < 90) cls.remove('derpy-bars-hide');           // near top: always shown
    else if (dy > 8) cls.add('derpy-bars-hide');         // scrolling down: tuck away
    else if (dy < -8) cls.remove('derpy-bars-hide');     // any upward nudge: bring back
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; onScroll(); });
  }, { passive: true });
})();


/*
 * Header nav restructure (theme-side DOM, menu config untouched):
 *   [Sell Us Your Cards ★highlight] [Events] [Graded Slabs] … [Discord →far right]
 * - "Sell Us Your Cards" pulled out of Community, highlighted, placed first
 * - "Upcoming Events" renamed "Events", placed before Graded Slabs
 * - "Discord" pulled out of Community, standalone at the far right
 * - "Trade In" removed from the nav (page itself stays reachable by URL)
 * - "Community" hidden if the moves leave it empty
 */
(function () {
  'use strict';
  function restructure() {
    var nav = document.querySelector('.full-menu > ul');
    if (!nav || nav.getAttribute('data-derpy-nav')) return;
    var tops = [].slice.call(nav.children);
    function topByText(re) {
      for (var i = 0; i < tops.length; i++) {
        var a = tops[i].querySelector(':scope > a');
        if (a && re.test(a.textContent.replace(/\s+/g, ' ').trim())) return tops[i];
      }
      return null;
    }
    var graded = topByText(/^graded slabs$/i);
    if (!graded) return;
    nav.setAttribute('data-derpy-nav', '1');

    function extract(re, hrefRe) {
      var links = nav.querySelectorAll('li li a');
      for (var i = 0; i < links.length; i++) {
        var t = links[i].textContent.replace(/\s+/g, ' ').trim();
        if (re.test(t) || (hrefRe && hrefRe.test(links[i].getAttribute('href') || ''))) {
          return links[i].closest('li');
        }
      }
      return null;
    }

    /* Trade In: drop from nav */
    var trade = extract(/^trade[\s-]?in/i, /trade-in/);
    if (trade) trade.parentNode.removeChild(trade);

    /* Sell Us Your Cards: highlighted, first */
    var sell = extract(/sell us your cards/i, /buylist/);
    if (sell) {
      sell.classList.add('derpy-nav-sell');
      nav.insertBefore(sell, graded);
    }

    /* Upcoming Events → "Events" (standalone — dropdown/megamenu stripped),
       before Graded Slabs; "Preorders" inserted right beside it */
    var events = topByText(/^upcoming events$/i) || topByText(/^events$/i);
    if (events) {
      var ea = events.querySelector(':scope > a');
      if (ea) {
        for (var n = 0; n < ea.childNodes.length; n++) {
          if (ea.childNodes[n].nodeType === 3 && /events/i.test(ea.childNodes[n].textContent)) {
            ea.childNodes[n].textContent = 'Events';
          }
        }
        var chev = ea.querySelector('svg, [class*="chevron"], .icon');
        if (chev && chev.parentNode) chev.parentNode.removeChild(chev);
      }
      events.classList.remove('menu-item-has-children');
      events.classList.remove('menu-item-has-megamenu');
      [].forEach.call(events.querySelectorAll(':scope > ul, :scope > .sub-menu, :scope > [class*="megamenu"], :scope > [class*="mega-menu"]'), function (sm) {
        sm.parentNode.removeChild(sm);
      });
      nav.insertBefore(events, graded);
      var pre = document.createElement('li');
      pre.className = graded.className || '';
      pre.classList.remove('menu-item-has-children');
      pre.classList.remove('menu-item-has-megamenu');
      var gA = graded.querySelector(':scope > a');
      pre.innerHTML = '<a class="' + ((gA && gA.className) || '') + '" href="/collections/preorders">Preorders</a>';
      nav.insertBefore(pre, graded);
    }

    /* Trading Card Games → "Other TCG" (dropdown kept) */
    var tcg = topByText(/^trading card games$/i);
    if (tcg) {
      var ta = tcg.querySelector(':scope > a');
      if (ta) {
        for (var m = 0; m < ta.childNodes.length; m++) {
          if (ta.childNodes[m].nodeType === 3 && /trading card games/i.test(ta.childNodes[m].textContent)) {
            ta.childNodes[m].textContent = 'Other TCG';
          }
        }
      }
    }

    /* Discord: standalone at the very right — into the header icon zone
       (next to account/cart) so it can never wrap the nav to a second row */
    var discord = extract(/^discord$/i, /discord\.gg/);
    if (discord) {
      var da = discord.querySelector('a');
      var iconZone = document.querySelector('.thb-secondary-area.thb-header-right');
      if (da && iconZone) {
        da.textContent = 'Join Discord';
        da.classList.add('derpy-nav-discord');
        iconZone.insertBefore(da, iconZone.firstChild);
        discord.parentNode.removeChild(discord);
      } else {
        discord.classList.add('derpy-nav-discord');
        nav.appendChild(discord);
      }
    }

    /* Community: removed from the nav entirely */
    var community = topByText(/^community$/i);
    if (community) community.parentNode.removeChild(community);

    /* ---- Mobile drawer: mirror the same structure ---- */
    var drawer = document.querySelector('.mobile-menu-drawer');
    if (drawer && !drawer.getAttribute('data-derpy-nav')) {
      drawer.setAttribute('data-derpy-nav', '1');
      var dLink = function (re) {
        var links = drawer.querySelectorAll('a');
        for (var i = 0; i < links.length; i++) {
          if (re.test(links[i].textContent.replace(/\s+/g, ' ').trim())) return links[i];
        }
        return null;
      };
      var liOf = function (a) { return a ? a.closest('li') : null; };
      /* pull Sell Us + Discord out of Community BEFORE removing it */
      var dSell = liOf(dLink(/sell us your cards/i));
      var dDiscordA = dLink(/^discord$/i);
      var dDiscord = liOf(dDiscordA);
      var dTrade = liOf(dLink(/^trade[\s-]?in/i));
      if (dTrade) dTrade.parentNode.removeChild(dTrade);
      var dEventsA = dLink(/^upcoming events$/i) || dLink(/^events$/i);
      var dEvents = liOf(dEventsA);
      if (dEventsA) {
        for (var k = 0; k < dEventsA.childNodes.length; k++) {
          if (dEventsA.childNodes[k].nodeType === 3 && /events/i.test(dEventsA.childNodes[k].textContent)) {
            dEventsA.childNodes[k].textContent = 'Events';
          }
        }
      }
      if (dEvents) {
        [].forEach.call(dEvents.querySelectorAll('ul, button, [class*="sub-menu"]'), function (x) {
          if (x.parentNode) x.parentNode.removeChild(x);
        });
        var dPre = document.createElement('li');
        dPre.className = dEvents.className || '';
        dPre.innerHTML = '<a href="/collections/preorders">Preorders</a>';
        dEvents.parentNode.insertBefore(dPre, dEvents.nextSibling);
      }
      var dTcgA = dLink(/^trading card games$/i);
      if (dTcgA) {
        for (var q = 0; q < dTcgA.childNodes.length; q++) {
          if (dTcgA.childNodes[q].nodeType === 3 && /trading card games/i.test(dTcgA.childNodes[q].textContent)) {
            dTcgA.childNodes[q].textContent = 'Other TCG';
          }
        }
      }
      var listRoot = (dEvents && dEvents.parentNode) || drawer.querySelector('ul');
      if (dSell && listRoot) {
        dSell.classList.add('derpy-nav-sell');
        listRoot.insertBefore(dSell, listRoot.firstChild);
      }
      /* drawer mirrors the desktop order: Sell Us → Events → Preorders → … */
      if (dEvents && listRoot) {
        listRoot.insertBefore(dEvents, dSell ? dSell.nextSibling : listRoot.firstChild);
        var dPreLi = dEvents.nextSibling && dEvents.parentNode.querySelector('a[href="/collections/preorders"]');
        dPreLi = dPreLi ? dPreLi.closest('li') : null;
        if (dPreLi) listRoot.insertBefore(dPreLi, dEvents.nextSibling);
      }
      if (dDiscordA) { dDiscordA.textContent = 'Join Discord'; dDiscordA.classList.add('derpy-mobile-discord'); }
      if (dDiscord && listRoot) listRoot.appendChild(dDiscord);
      var dCommunity = liOf(dLink(/^community$/i));
      if (dCommunity) dCommunity.parentNode.removeChild(dCommunity);
    }
  }
  if (document.readyState !== 'loading') restructure();
  else document.addEventListener('DOMContentLoaded', restructure);
})();


/*
 * INFINITE GALLERY (V2 only — gated on <html data-derpy-infinite>, which only
 * the Claude V2 theme.liquid sets; dormant everywhere else).
 *
 * Composition: the gallery opens with 16 cards (2 clean rows of 8 on desktop,
 * 8 rows of 2 on mobile); the rest of page 1 plus prefetched pages sit in an
 * in-memory buffer, so scrolling appends instantly (fetches hide behind the
 * buffer). After 4 automatic appends a "Show more" button takes over so the
 * footer stays reachable; clicking re-arms auto-load. The URL quietly tracks
 * the deepest fetched page (?page=N).
 *
 * Also mounts the contextual jump button: ↑ appears once you've scrolled;
 * tapping it remembers your spot and turns into ↓ to return there.
 */
(function () {
  'use strict';
  if (!document.documentElement.hasAttribute('data-derpy-infinite')) return;

  var INITIAL_VISIBLE = 16;
  var BATCH = 16;          // cards appended per trigger
  var LOW_WATER = 20;      // prefetch when buffer drops below this
  var AUTO_MAX = 4;        // auto-appends before the "Show more" pause

  function qp() { return new URLSearchParams(location.search); }
  function pageUrl(n) {
    var p = qp();
    if (n <= 1) p.delete('page'); else p.set('page', String(n));
    var qs = p.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- contextual jump button (top ⇄ return) ---------- */
  function mountJump() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'derpy-jump';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 14 12 7 19 14"></polyline></svg>';
    document.body.appendChild(btn);
    var returnY = null, jumping = false, jumpTimer = null;
    function setState(s) {
      btn.classList.toggle('is-visible', s !== 'hidden');
      btn.classList.toggle('is-return', s === 'return');
      btn.setAttribute('aria-label', s === 'return' ? 'Return to where you were' : 'Back to top');
    }
    function onScroll() {
      if (jumping) return;
      var y = window.scrollY || document.documentElement.scrollTop;
      if (returnY !== null) {
        // user re-engaged with the top of the page → drop the return offer
        if (y > 400) { returnY = null; setState(y > window.innerHeight * 1.2 ? 'top' : 'hidden'); }
        else setState('return');
        return;
      }
      setState(y > window.innerHeight * 1.2 ? 'top' : 'hidden');
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }, { passive: true });
    /* rAF glide — native behavior:'smooth' is unreliable with some
       extensions/embeds, so animate the scroll ourselves (easeOutCubic).
       The done callback (not a timer) releases the state machine, so the
       "return" state can't be cancelled by a slow animation. */
    function glide(toY, done) {
      if (reducedMotion) { window.scrollTo(0, toY); if (done) done(); return; }
      var from = window.scrollY || document.documentElement.scrollTop;
      var delta = toY - from;
      if (!delta) { if (done) done(); return; }
      var dur = Math.min(650, 250 + Math.abs(delta) * 0.05);
      var t0 = performance.now();
      function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        window.scrollTo(0, Math.round(from + delta * e));
        if (p < 1) requestAnimationFrame(step);
        else if (done) done();
      }
      requestAnimationFrame(step);
    }
    btn.addEventListener('click', function () {
      jumping = true;
      clearTimeout(jumpTimer);
      var release = function () { jumping = false; onScroll(); };
      jumpTimer = setTimeout(release, 4000); // safety net only — done() is the real release
      if (btn.classList.contains('is-return') && returnY !== null) {
        var target = returnY; returnY = null;
        glide(target, release);
      } else {
        returnY = window.scrollY || document.documentElement.scrollTop;
        glide(0, release);
      }
    });
    onScroll();
  }

  /* ---------- infinite gallery ---------- */
  function boot() {
    var grid = document.getElementById('product-grid');
    var pag = document.querySelector('pagination-theme.pagination');
    if (!grid || !pag) return;
    var nums = [].map.call(pag.querySelectorAll('ul.page-numbers li a, ul.page-numbers li span.page'), function (el) {
      return parseInt(el.textContent, 10);
    }).filter(function (n) { return !isNaN(n); });
    var totalPages = nums.length ? Math.max.apply(null, nums) : 1;

    var fetchedPage = parseInt(qp().get('page') || '1', 10) || 1;
    var totalResults = (function () {
      var m = document.documentElement.innerHTML.match(/"total":(\d+)/);
      return m ? parseInt(m[1], 10) : 0;
    })();
    var seen = {};
    [].forEach.call(grid.querySelectorAll('a.product-card--image-link'), function (a) {
      seen[(a.getAttribute('href') || '').split('?')[0]] = 1;
    });

    var pending = [];         // detached, ready-to-append card cells (in order)
    var fetching = false, done = false, autoAppends = 0;

    /* trim the opening view to 16 cards; the extras seed the buffer */
    (function () {
      var cells = [].slice.call(grid.children);
      var cardCount = 0, cutIndex = -1;
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].querySelector && cells[i].querySelector('.product-card, product-card')) {
          cardCount++;
          if (cardCount === INITIAL_VISIBLE) { cutIndex = i; break; }
        }
      }
      if (cutIndex > -1) {
        for (var j = cutIndex + 1; j < cells.length; j++) {
          if (cells[j].querySelector && cells[j].querySelector('.product-card, product-card')) {
            pending.push(grid.removeChild(cells[j]));
          }
        }
      }
    })();

    if (totalPages < 2 && !pending.length) return; // single short page — nothing to do

    var bar = document.createElement('div');
    bar.className = 'derpy-inf';
    bar.innerHTML = '<div class="derpy-inf__spin" hidden></div>' +
      '<button type="button" class="derpy-inf__more" hidden>Show more</button>' +
      '<div class="derpy-inf__count"></div>';
    pag.parentNode.insertBefore(bar, pag);
    pag.style.display = 'none';
    var spin = bar.querySelector('.derpy-inf__spin');
    var moreBtn = bar.querySelector('.derpy-inf__more');
    var countEl = bar.querySelector('.derpy-inf__count');

    function shownCount() { return grid.querySelectorAll('.product-card, product-card').length; }
    function updateCount(suffix) {
      countEl.textContent = 'Showing ' + shownCount() + (totalResults ? ' of ' + totalResults : '') + ' items' + (suffix || '');
      var tb = document.querySelector('.derpy-tb-count');
      if (tb) tb.textContent = shownCount() + ' shown';
    }
    function reveal(scope) {
      [].forEach.call((scope || grid).querySelectorAll('.product-card--image-primary:not([data-derpy-revealed]), .product-card--image:not([data-derpy-revealed])'), function (el) {
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('transform', 'none', 'important');
        el.setAttribute('data-derpy-revealed', '1');
      });
    }
    function exhausted() { return fetchedPage >= totalPages && pending.length === 0; }
    function finish() {
      done = true;
      spin.hidden = true;
      moreBtn.hidden = true;
      if (io) io.disconnect();
      updateCount(' — end of results');
    }

    function ensureBuffer() {
      if (fetching || fetchedPage >= totalPages) return;
      if (pending.length >= LOW_WATER) return;
      fetching = true;
      fetch(pageUrl(fetchedPage + 1), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.getElementById('product-grid');
          var cells = g ? [].slice.call(g.children) : [];
          for (var i = 0; i < cells.length; i++) {
            var a = cells[i].querySelector && cells[i].querySelector('a.product-card--image-link');
            if (!a) continue;
            var key = (a.getAttribute('href') || '').split('?')[0];
            if (!key || seen[key]) continue;
            seen[key] = 1;
            pending.push(document.importNode(cells[i], true));
          }
          fetchedPage++;
          try { history.replaceState(null, '', pageUrl(fetchedPage)); } catch (e) {}
          fetching = false;
          ensureBuffer(); // top up further if a big append drained us
        })
        .catch(function () { fetching = false; });
    }

    function appendBatch(fromButton) {
      if (done) return;
      if (!pending.length) {
        if (exhausted()) { finish(); return; }
        // buffer empty but more pages exist → show spinner while the fetch lands
        if (!fetching) ensureBuffer();
        spin.hidden = false;
        var wait = setInterval(function () {
          if (pending.length || exhausted()) {
            clearInterval(wait);
            spin.hidden = true;
            if (pending.length) appendBatch(fromButton); else finish();
          }
        }, 150);
        return;
      }
      var frag = document.createDocumentFragment();
      var n = Math.min(BATCH, pending.length);
      for (var i = 0; i < n; i++) {
        var cell = pending.shift();
        cell.classList.add('derpy-inf-new');
        frag.appendChild(cell);
      }
      grid.appendChild(frag);
      reveal();
      try { if (window.DerpyInitPrices) window.DerpyInitPrices(); } catch (e) {}
      updateCount();
      if (exhausted()) { finish(); return; }
      if (!fromButton) autoAppends++;
      if (autoAppends >= AUTO_MAX) moreBtn.hidden = false;
      ensureBuffer();
    }

    moreBtn.addEventListener('click', function () { autoAppends = 0; moreBtn.hidden = true; appendBatch(true); });
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && moreBtn.hidden && !done) appendBatch(false);
      }, { rootMargin: '1800px 0px' }); /* wide margin: fast scrollers who overshoot to the footer keep the feed loading */
      /* the opening view holds at exactly 16 — the loader arms on the first
         real scroll, not on page load */
      window.addEventListener('scroll', function armOnce() {
        window.removeEventListener('scroll', armOnce);
        io.observe(bar);
      }, { passive: true });
    } else {
      moreBtn.hidden = false;
    }
    updateCount();
    ensureBuffer(); // prefetch page 2 immediately — first appends are instant
    mountJump();
  }

  /* wait until the app has rendered the grid + pagination */
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (document.querySelector('#product-grid .product-card') && document.querySelector('pagination-theme.pagination')) {
      clearInterval(iv);
      boot();
    } else if (tries > 60) { clearInterval(iv); }
  }, 250);
})();


/*
 * PDP composition (desktop): the media column had a tall empty run under the
 * card stage. Pull the "You may also like" + "Recently viewed" sections up
 * into that column as compact panels beside the buy module. Mobile keeps the
 * theme's normal stacked flow (no relocation below 990px).
 */
(function () {
  'use strict';
  function relocate() {
    try {
      if (window.innerWidth < 990) return;
      if (!/^\/products\//.test(location.pathname)) return;
      var container = document.querySelector('.product-section .product-image-container');
      if (!container) return;
      var mediaCol = container.closest('.product-images') || container.parentElement;
      if (!mediaCol) return;
      var moved = false;
      ['[id*="product-recommendations"]', '.section-recently-viewed-products'].forEach(function (sel) {
        var sec = document.querySelector('.shopify-section' + (sel[0] === '[' ? sel : sel) );
        if (!sec) sec = document.querySelector(sel);
        if (sec && !mediaCol.contains(sec)) {
          sec.classList.add('derpy-side-panel');
          mediaCol.appendChild(sec);
          moved = true;
        }
      });
      if (moved) document.body.classList.add('derpy-pdp-side');
    } catch (e) {}
  }
  if (document.readyState !== 'loading') setTimeout(relocate, 400);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(relocate, 400); });
})();

